/**
 * 用于将api原始数据转换为业务数据，主要处理属性的字段转换关系
 */

// 所有的trans方法都将改变源数据
// function transProduct (obj: any) {

// }
// function transScale (obj: any) {

// }
// function transModifierGroup (obj: any) {

// }
// function transGroup (obj: any) {

// }
// function transCategory (obj: any) {
// }

function convertToTinyKey (key: string, attribute: string) {
  const newkey: string = key.substr(attribute.length)
  return newkey.substr(0, 1).toLowerCase() + newkey.substr(1)
}
/** 清理所有的*Id 和 *No 转换为id no */
// productGroup* -> group*
// productScale* -> scale*
const ormAtt: any = {
  productModifier: 'modifiers',
  productGroupId: 'groupId',
  productGroupNo: 'groupNo',
  productScaleId: 'scaleId',
  productScaleNo: 'scaleNo',
  productScale: 'scales',
  areaName: 'name',
  storeDesks: 'desks',
  productModifierGroup: 'modifierGroups',
  groupMaxCnt: 'maxCnt'
}
function clearKey (obj: any, attribute: string = ''): any {
  if (Array.isArray(obj)) {
    return obj.map(_obj => clearKey(_obj, attribute))
  }
  for (const key in obj) {
    let okey = key
    if (!key.indexOf(attribute)) {
      okey = convertToTinyKey(key, attribute)
    } else {
      okey = ormAtt[key] || okey
    }
    if (okey !== key) {
      obj[okey] = obj[key]
      delete obj[key]
      if (okey === 'scaleGroup') {
        obj[okey] = clearKey(obj[okey], key)
      }
    }
    if (Array.isArray(obj[okey])) {
      // .substr(0, key.length - 1)
      obj[okey] = clearKey(obj[okey], key)
    }
  }
  return obj
}
const ormTransform = {
  clearKey
}
export default ormTransform
